import { useContext, useEffect, useState } from 'react'
import PageContext from '../../global_state/context/PageContext'

import SCSS from 'assets/scss/CreateOnlineAccount.module.scss'
import FormSCSS from 'assets/scss/Form.module.scss'
import { PageType } from 'types/PageI'
import Loader from 'components/Loader'
import { ForgottenPassowrdService } from 'services/user_services/ForgottenPasswordService'
import content from 'languages/ForgottenPassword.json'
import Title from 'components/Title'

import AppSCSS from 'assets/scss/App.module.scss'

function ForgottenPassword() {

    const {page, dispatchPage}  = useContext(PageContext)
    let language = page.settings.language

    
    const [loading, setLoading] = useState(false)
    const [user_email, setUserEmail] = useState('')
    const [forgotten_passowrd_response, setResponse] = useState<any>()

    const handleSubmit = async (event) => {
        event.preventDefault()
        // console.log(event);
        setLoading(true)
        
        setResponse(await ForgottenPassowrdService(user_email, language))

    }

    useEffect(() => {
        // console.log("forgotten_passowrd_response");
        
        // console.log(forgotten_passowrd_response);
        setLoading(false)

        if (forgotten_passowrd_response === "item_email_required") {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: forgotten_passowrd_response
                    }
                }
            })
            return 
        } 

        if (forgotten_passowrd_response === "email_not_found_error") {
            dispatchPage({type: "render", payload: {page: PageType.email_not_found, props: {page: PageType.forgotton_password}}})
            return 
        }         

        if (forgotten_passowrd_response === "email_send") {
            dispatchPage({type: "render", payload: {page: PageType.email_send, props: {page: PageType.entrance}}})
            
            // TODO: allow reset password from the diffrent device
            // dispatchPage({type: "render", payload: {page: PageType.email_send, props: {page: PageType.entrance}}})
        } 
        
        
    }, [forgotten_passowrd_response])

    useEffect(() => {
        // console.log("mount ForgottenPassword component".toUpperCase());
        
    }, [])
    if (loading) {
        return (
            <Loader/>
        )
    }


    return (
        <div className={[SCSS.create_online_account, FormSCSS.form_wrapper].join(" ")}>
            <Title back_arrow={true} title={content[language].title} page={PageType.entrance}/>
            
            <form 
                className={FormSCSS.form} 
                onSubmit={(event) => {handleSubmit(event)}} >
                
                <div className={SCSS.info_text}>{content[language].text}</div>

                <label className={FormSCSS.label} htmlFor="email">
                    <input 
                        className={FormSCSS.input}
                        type="text" 
                        name='email'
                        id='email'
                        placeholder={content[language].email_placeholder}
                        value={user_email}
                        onChange={(e) => {setUserEmail(e.target.value)}}/>
                </label>
                <button className={[AppSCSS.button, AppSCSS.red].join(" ")} type="submit">{content[language].button_submit}</button>
            
            </form>

        </div>
    )
}

export default ForgottenPassword